import LegalStatement from "../../../../src/pages/use-cases/page-content/agreements-and-contracts/legal-letters-and-statements.md";
import * as React from 'react';
export default {
  LegalStatement,
  React
};